export enum CatalogFilterOptions {
  All = 'ALL',
  BIAssets = 'BIASSETS',
  CriticalAssets = 'CRITICALASSETS',
}
